// extracted by mini-css-extract-plugin
module.exports = {"h100":"TradesTable_h100_2Hwrv","w100":"TradesTable_w100_2o-Fu","relative":"TradesTable_relative_3DTEo","preloader":"TradesTable_preloader_3WXLp"};